
import { defineComponent } from 'vue';
import Header from '@/components/Header/Header.vue';
import SurveyDetailsHeader from '@/components/SurveyDetails/SurveyDetailsHeader/index.vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'SurveyDetail',
  components: {
    Header,
    SurveyDetailsHeader,
  },
  setup() {
    const store = useStore();
    const storedId = store.getters['survey/getId'];
    const route = useRoute();
    const id = route.params?.id;
    if (!storedId) {
      store.dispatch('survey/updateSurvey', id);
    }
  },
});
